import
  React, {
  useEffect,
  useState
} from 'react';

import {
  useHistory
} from 'react-router-dom';

import {
  Environment
} from '@vodacom/web-env';

import {
  ServiceCard,
  VContainer
} from '@vodacom/web-common';

import {
  DrupalProvider
} from 'providers';

import {
  CacheKeys,
  Icons
} from '../../../constants';

import {
  handleUtagLinkEvent
} from 'helpers';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

const FreeServicesUI = () => {

  const history = useHistory();
  const mountedRef = React.useRef(true);

  const getPillarsMeta = async () => {

    const response = await DrupalProvider.getCachedItem(
      CacheKeys.PillarMeta,
      null,
      DrupalProvider.getPillarMeta
    );

    if (!mountedRef.current) {
      return;
    }

    if (!response.ok) {
      setPageState({
        ...pageState,
        loading: false,
        error: response.error
      });

      return;
    }

    setPageState({
      ...pageState,
      loading: false
    });

    setPillars(response.result);
  };

  const buildServiceCardsCarousel = () => {

    const serviceCards = [];

    for (const service of pillars) {
      if (!service) {
        continue;
      }

      const goToListPage = () => {

        const category = service.category.toLowerCase();

        handleUtagLinkEvent({
          event_action: 'click',
          event_category: 'free services cards',
          event_label: category
        });

        return history.push(`/pillars/${category}`);
      };

      const icon = service.category.replace(/[^0-9a-z-A-Z]/g, '');

      serviceCards.push(
        <ServiceCard
          key={service.category.toLowerCase()}
          heading={service.title}
          body={service.description}
          backgroundImageUrl={`${Environment.current.drupalBaseUrl}${service.cardImage}`}
          iconUrl={Icons[icon]}
          onClick={goToListPage}
          margin={'0 0 16px'}
        />
      );
    }

    return serviceCards;
  };

  const [ pillars, setPillars ] = useState([]);

  const [ pageState, setPageState ] = useState({
    loading: true,
    error: null
  });

  useEffect(() => {
    const init = async () => {
      await getPillarsMeta();
    };

    init();

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return (

    <HandleRender
        isLoading={pageState.loading}
        isError={pageState.error}>
      <VContainer
        padding={'16px'}>

      { pillars &&
        buildServiceCardsCarousel()
      }

      </VContainer>
    </HandleRender>
  );
};

FreeServicesUI.pageName = 'cbu: connectu: free services: home';

FreeServicesUI.tagViewData = {
  page_section: 'free service home'
};

export const FreeServices = withScreenViewTagging(FreeServicesUI);
